import { Box, Button, Dialog, DialogActions, Grid, IconButton, LinearProgress, Skeleton, Slide, Stack, TableContainer, Typography } from "@mui/material";
import { forwardRef, useState } from "react";
import { dateUsaToTimestamp, getOfficeMeta, sortJsonArrayByKey } from "../frames/common";
import { generateInvoice, getInvoiceFuel, getInvoiceGst, getInvoicePrice, getInvoiceTaxable, getInvoiceTotalPrice } from "./billing_halper";
import { EditTwoTone } from "@mui/icons-material";
import './billing.css';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function BillPriview({ open, client, particular, onClose }) {
    const [office, setOffice] = useState(null);
    const [customSeries, setCustomSeries] = useState(false);
    const [billNumber, setBillNumber] = useState("");
    const [mBillDate, setMBillDate] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    if (!client || !particular || particular.length === 0 || !open) return (<></>);
    particular = sortJsonArrayByKey(particular, "sl_no");

    particular = particular.map((item, idx) => ({ ...item, sl_no: idx + 1 }));

    const handleSelfClose = (e) => {
        if (isLoading) return;
        setBillNumber("");
        setError("");
        setCustomSeries(false);
        setOffice(null);
        onClose(e);
    }

    const handleGenerate = () => {
        const sumPriceFuel = getInvoiceTaxable(particular);
        const sumPriceFuelGst = getInvoiceTotalPrice(particular);
        if (customSeries) {
            if (billNumber === "" || mBillDate === "") {
                setError("Invoice bill number or invoice date is missing.");
                return;
            }
        }
        const client_details = {
            "ac_id": client["ac_id"],
            "client_id": client["client_id"],
            "name": client["name"],
            "gst_num": client["gst_num"],
            "email": client["email"],
            "phone": client["phone"],
            "billing_add_1": client["billing_add_1"],
            "billing_add_2": client["billing_add_2"],
            "billing_add_3": client["billing_add_3"],
            "billing_add_state": client["billing_add_state"],
            "billing_add_zip": client["billing_add_zip"],
            "shipping_add_1": client["shipping_add_1"],
            "shipping_add_2": client["shipping_add_2"],
            "shipping_add_3": client["shipping_add_3"],
            "shipping_add_state": client["shipping_add_state"],
            "shipping_add_zip": client["shipping_add_zip"],
        };
        const office_details = {
            "id": office["id"],
            "name": office["name"],
            "add_1": office["add_1"],
            "add_2": office["add_2"],
            "add_3": office["add_3"],
            "pincode": office["pincode"],
            "email": office["email"],
            "phone": office["phone"],
            "logo": office["logo"],
        };

        const _json = {
            "particular": particular, "bill_number": customSeries ? billNumber : "", "bill_date": customSeries ? mBillDate : "",
            "client": client_details, "office": office_details, "taxable": sumPriceFuel, "amount": sumPriceFuelGst
        };
        setError("");
        setIsLoading(true);
        generateInvoice(_json).then((res) => {
            handleSelfClose("success");
            setIsLoading(false);
        }).catch((err) => {
            setError(err.message);
            setIsLoading(false);
        });
    }

    const handleCustomSeries = () => {
        setBillNumber("");
        setCustomSeries(!customSeries);
    }

    const handleBillNumberChange = (e) => {
        setBillNumber(e.target.value.toUpperCase());
    }

    const handleBillDateChange = (e) => {
        setMBillDate(dateUsaToTimestamp(e.target.value));
    }

    if (office === null) {
        setOffice(false);
        getOfficeMeta().then((res) => {
            setOffice(res);
        }).catch((err) => {
            console.error(err);
        });
    }

    return (
        <Dialog open={open} onClose={handleSelfClose} TransitionComponent={Transition} maxWidth="25cm">
            <Box sx={{ mt: 1 }}>
                <Typography variant="h5" align="center">Tax Invoice</Typography>
                {office === null || office === false ?
                    <Box alignSelf={"center"} alignContent={"center"} align="center">
                        <Stack spacing={0.5}>
                            <Skeleton variant="rectangular" width={250} height={15} />
                            <Skeleton variant="rectangular" width={250} height={15} />
                            <Skeleton variant="rectangular" width={250} height={10} />
                            <Skeleton variant="rectangular" width={250} height={5} />
                        </Stack>
                    </Box> :
                    <Box alignSelf={"center"} alignContent={"center"} align="center">
                        <Typography variant="body2" align="center">{office.name}</Typography>
                        <Typography variant="body2" align="center">{office.add_1}</Typography>
                        <Stack spacing={0.5}>
                            <Skeleton variant="rectangular" width={250} height={10} />
                            <Skeleton variant="rectangular" width={250} height={5} />
                        </Stack>
                    </Box>
                }
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 9 }} >
                        <Box sx={{ p: 1 }}>
                            <Typography variant="subtitle1">{client.client_id}</Typography>
                            <Typography variant="body2">{client.name}</Typography>
                            <Stack spacing={0.5}>
                                <Skeleton variant="rectangular" width={250} height={10} />
                                <Skeleton variant="rectangular" width={250} height={5} />
                                <Skeleton variant="rectangular" width={250} height={5} />
                            </Stack>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 3 }}>
                        <IconButton aria-label="custom bill series" size="small" onClick={handleCustomSeries}>
                            <EditTwoTone color="secondary" fontSize="inherit" />
                        </IconButton>
                        <input type="date" onChange={handleBillDateChange} disabled={!customSeries} style={{ color: "black", border: customSeries ? "1px solid #800080" : "1px solid white", padding: "2px", borderCollapse: "collapse" }} />
                        <input type="text" value={billNumber} onChange={handleBillNumberChange} disabled={!customSeries} style={{ color: "black", border: customSeries ? "1px solid #800080" : "1px solid white", padding: "4px", borderCollapse: "collapse" }} placeholder={customSeries ? "Enter Invoice Number" : "Auto"} />
                        <Stack spacing={0.5}>
                            <Skeleton variant="rectangular" height={10} />
                            <Skeleton variant="rectangular" height={5} />
                            <Skeleton variant="rectangular" height={5} />
                        </Stack>
                    </Grid>
                </Grid>
            </Box>

            <TableContainer>
                <table className="nowrap bill-priview" style={{ margin: "0 2px", width: "calc(100% - 4px)" }}>
                    <thead>
                        <tr>
                            <th><Typography variant="body2">SL</Typography></th>
                            <th><Typography variant="body2">Date</Typography></th>
                            <th colSpan={3}><Typography variant="body2">Description</Typography></th>
                            <th><Typography variant="body2">HSN</Typography></th>
                            <th><Typography variant="body2">Quantity</Typography></th>
                            <th><Typography variant="body2">Rate</Typography></th>
                            <th><Typography variant="body2">Price</Typography></th>
                            <th><Typography variant="body2">Fuel</Typography></th>
                            <th><Typography variant="body2">Taxable</Typography></th>
                            <th><Typography variant="body2">GST</Typography></th>
                            <th><Typography variant="body2">Total</Typography></th>
                        </tr>
                    </thead>
                    <tbody>
                        {particular.map((item, index) =>
                            <tr key={index}>
                                <td>
                                    <Typography variant="body2">{item.sl_no}</Typography>
                                </td>
                                <td>
                                    <Typography variant="body2">{item.date}</Typography>
                                </td>
                                <td colSpan={item.hsn === 996812 ? 0 : 3}>
                                    <Typography variant="body2"><strong>{item.title}</strong></Typography>
                                    <Typography variant="caption">{item.description}</Typography>
                                </td>
                                {item.hsn === 996812 ?
                                    <>
                                        <td>
                                            <Typography variant="body2">{item.destination}</Typography>
                                        </td>
                                        <td align="right">
                                            <Typography variant="body2">{item.weight >= 1000 ? (item.weight / 1000).toFixed(3) + " Kg" : item.weight + " Grm"}</Typography>
                                        </td>
                                    </>
                                    :
                                    ""
                                }
                                <td>
                                    <Typography variant="body2">{item.hsn}</Typography>
                                </td>
                                <td align="right">
                                    <Typography variant="body2">{item.quantity}</Typography>
                                </td>
                                <td align="right">
                                    <Typography variant="body2">{item.rate.toFixed(2)}</Typography>
                                    {item.other !== 0 ? Math.abs(item.other) < 10 ?
                                        <Typography variant="caption">Adj: {item.other.toFixed(2)}</Typography> :
                                        item.other < 0 ? <Typography variant="caption">Disc: {item.other.toFixed(2)}</Typography> :
                                            <Typography variant="caption">Oth: {item.other.toFixed(2)}</Typography> : ""}
                                </td>
                                <td align="right">
                                    <Typography variant="body2">{item.price.toFixed(2)}</Typography>
                                </td>
                                <td align="right">
                                    <Typography variant="body2">{item.fuel.toFixed(2)}</Typography>
                                </td>
                                <td align="right">
                                    <Typography variant="body2">{(item.price + item.fuel).toFixed(2)}</Typography>
                                </td>
                                <td align="right">
                                    <Typography variant="body2">{item.gst.toFixed(2)}</Typography>
                                </td>
                                <td align="right">
                                    <Typography variant="body2">{(item.price + item.fuel + item.gst).toFixed(2)}</Typography>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </TableContainer>
            <TableContainer>
                <table className="nowrap bill-priview" style={{ margin: "2px", width: "calc(100% - 4px)" }}>
                    <tbody>
                        <tr>
                            <td align="right">
                                <Typography variant="body2">Service Value</Typography>
                            </td>
                            <td className="rupee"><Typography variant="body2">₹</Typography></td>
                            <td align="right" className="amount">
                                <Typography variant="body2">{getInvoicePrice(particular).toFixed(2)}</Typography>
                            </td>
                        </tr>
                        <tr>
                            <td align="right">
                                <Typography variant="body2">Fuel Charge</Typography>
                            </td>
                            <td className="rupee"><Typography variant="body2">₹</Typography></td>
                            <td align="right" className="amount">
                                <Typography variant="body2">{getInvoiceFuel(particular).toFixed(2)}</Typography>
                            </td>
                        </tr>
                        <tr>
                            <td align="right">
                                <Typography variant="body2">Taxable Booking</Typography>
                            </td>
                            <td className="rupee"><Typography variant="body2">₹</Typography></td>
                            <td align="right" className="amount">
                                <Typography variant="body2">{getInvoiceTaxable(particular).toFixed(2)}</Typography>
                            </td>
                        </tr>
                        <tr>
                            <td align="right">
                                <Typography variant="body2">GST (SGST + CGST)</Typography>
                            </td>
                            <td className="rupee"><Typography variant="body2">₹</Typography></td>
                            <td align="right" className="amount">
                                <Typography variant="body2">{getInvoiceGst(particular).toFixed(2)}</Typography>
                            </td>
                        </tr>
                        <tr>
                            <td align="right">
                                <Typography variant="body2" fontWeight={"bold"}>Total Payable</Typography>
                            </td>
                            <td className="rupee"><Typography variant="body2" fontWeight={"bold"}>₹</Typography></td>
                            <td align="right" className="amount">
                                <Typography variant="body2" fontWeight={"bold"}>{getInvoiceTotalPrice(particular).toFixed(2)}</Typography>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </TableContainer>
            {isLoading ? <LinearProgress color="secondary" /> : ""}
            <DialogActions>
                <Typography variant="caption" color="error">{error}</Typography>
                <Button onClick={handleSelfClose} disabled={isLoading}>Cancel</Button>
                <Button onClick={handleGenerate} autoFocus disabled={isLoading}>
                    Generate
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default BillPriview;